// İSG uzmanı portalı — Kontrol aşaması (DepartmentReview) TanStack Query anahtarları (api-contract
// §31.4/§31.5, tenant-scoped). Kuyruk (departmanın bekleyen izinleri; düz `WorkPermitDto[]`) + tek
// iznin **departman-kapsamlı** detayı (`?department=`; kendi kendine yeterli — izin/personel/belge/
// eğitim/araç/AI-notu/onaylar) ayrı anahtarlar; invalidasyon önek (`['department-review']`) ile.
// Detay departmana göre değiştiğinden anahtar departmanı da içerir (§14 `permitsKeys` KULLANILMAZ).

import type { DepartmentReviewListParams, PermitApprovalDepartment } from '@isgportal/shared';

export const departmentReviewKeys = {
  /** Tüm Kontrol sorgularının kök öneki — invalidasyon için. */
  all: () => ['department-review'] as const,
  /** Departmanın bekleyen izinleri kuyruğu (parametre varyantlarını kapsar). */
  list: () => ['department-review', 'list'] as const,
  /** Sayfalı kuyruk — parametreli. */
  listParams: (params: DepartmentReviewListParams) =>
    ['department-review', 'list', params] as const,
  /** Erişim sondası (gate) — hafif kuyruk probu (page=1, pageSize=1). */
  access: () => ['department-review', 'access'] as const,
  /** Tek iznin departman-kapsamlı detayı (departmana göre değişir). */
  detail: (uuid: string, department: PermitApprovalDepartment) =>
    ['department-review', 'detail', uuid, department] as const,
} as const;
